import { render, staticRenderFns } from "./Datatables.vue?vue&type=template&id=074dbf1c&scoped=true"
import script from "./Datatables.vue?vue&type=script&lang=js"
export * from "./Datatables.vue?vue&type=script&lang=js"
import style0 from "./Datatables.vue?vue&type=style&index=0&id=074dbf1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074dbf1c",
  null
  
)

export default component.exports